import React, {useEffect, useState} from "react"
import Holdings from "./Holdings";
import {useHistory} from "react-router-dom";

const Profile = ({user}) => {
  const history = useHistory();

  useEffect(() => {
    if (user === undefined || Object.keys(user).length === 0) {
      history.push('/')
    }
  }, [user, history])

  return (
    <>
      <Holdings user={user} />
    </>
  )
}

export default Profile